import React, { Component } from 'react';
import {
    Card,
    Col,
    Row,
    Statistic,
    Icon,
    List,
    Tag,
    Tooltip 
} from "antd";
import { Link } from "react-router-dom";
class skillCard extends Component {
    constructor(props) {
        super(props);
        console.log('props: ', props);
        let data = Object.keys(props.skills).map(el => ({title:el,count:props.skills[el]}))
        data.sort((a, b) => Number(b.count) - Number(a.count));
        this.state = {
            listdata:data ? data : []
        }
    }
    
    render() {
        return (<div>
            <h4>Number of {(this.props.category && this.props.category)} with skills (click on skill name to view the list)</h4>
            <List
            grid={{ gutter: 5, xs: 2,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 5,
                xxl: 5, }}
            pagination={{defaultPageSize:12,showLessItems:true,simple:true }}
            dataSource={this.state.listdata}
            renderItem={item => (
              <List.Item>
                <Tooltip title={"Number of "+(this.props.category && this.props.category) + " with " + (item.title) +" Skill - " + (item.count) + " (click to view the list)" }>
               <Link to={`/home/skills/${item.title}?Category=${(this.props.category && this.props.category)}${(this.props.campus=='ADMIN' ? "" : "&Campus="+this.props.campus)}`}> <Card  bodyStyle={{padding:10,overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}} hoverable  bordered={true}>
               <Tag color="blue">{item.title }</Tag>  - <Tag>{item.count}</Tag>
              </Card></Link>
              </Tooltip>
              </List.Item>
            )}
          /> 
            </div>);
    }
}

export default skillCard;
